import { defaultPrecision } from '@/config/money'

/**
 * Converts a major-unit money amount to integer minor units using `defaultPrecision`.
 * Returns `undefined` when the input is absent, NaN, or non-finite so downstream
 * `MoneyCell` components can render their placeholder instead of a broken value.
 *
 * @example
 * majorToMinor(12.5)       // → 1250   (dollars → cents, precision 2)
 * majorToMinor(0.01)       // → 1
 * majorToMinor(0)          // → 0
 * majorToMinor(null)       // → undefined
 * majorToMinor(undefined)  // → undefined
 * majorToMinor(NaN)        // → undefined
 * majorToMinor(Infinity)   // → undefined
 */
export function majorToMinor(amount: number | null | undefined): number | undefined {
  if (typeof amount !== 'number' || !Number.isFinite(amount)) return undefined
  return Math.round(amount * 10 ** defaultPrecision)
}
